import { z } from 'zod';

export const UserRole = z.enum(['embeddedUser', 'user', 'manager', 'toroAdmin']);
export type UserRole = z.infer<typeof UserRole>;

export const AccessLevel = z.enum(['public', ...UserRole.options]);
export type AccessLevel = z.infer<typeof AccessLevel>;

// List of access levels. Higher level roles include all the permissions of lower roles
const ACCESS_LEVELS = {
  public: 0,
  embeddedUser: 1,
  user: 5,
  manager: 9,
  toroAdmin: 100,
} as const satisfies Record<AccessLevel, number>;

/**
 * Returns true if the given user role is >= the target AccessLevel
 * @param targetLevel - The AccessLevel of the protected resource
 * @param userLevel - The user's role, if any
 */
export function doesUserHaveAccess(targetLevel: AccessLevel, userLevel?: AccessLevel | null) {
  return ACCESS_LEVELS[userLevel ?? 'public'] >= ACCESS_LEVELS[targetLevel];
}
